import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

export function BottomInfoView() {
  return (
    <Info className={Typography.BODY_13_REGULAR}>
      <ItemStrong>
        • 예상 최저가는 <Strong>멤버십 마일리지 적립 대상 스토어 상품</Strong>에 한해 제공됩니다.
      </ItemStrong>
      <Item>• 예상 최저가는 옵션 판매가 중 최저금액 1개 기준으로 계산됩니다.</Item>
      <Item>• 최소 결제금액을 예측하는 용도로만 사용되며, 실제 결제금액과 다를 수 있습니다.</Item>
      <Item>• 예상 최저가 적용 혜택은 주문 단계에서 다시 한번 적용해 주시기 바랍니다.</Item>
      <Item>
        • 고객님이 다운받을 수 있는 쿠폰과 다운받은 쿠폰 중 상품에 사용할 수 있는 최대 할인 쿠폰을 적용합니다. 미보유한 쿠폰은 반드시 다운로드 받은 후 주문서에서 적용하시기 바랍니다.
      </Item>
      <Item>• 결제 할인은 카드 발급 여부 및 실적에 따라 다르게 적용될 수 있습니다.</Item>
      <Item>• 함께 구매하는 상품의 쿠폰 적용 조건 등에 따라 실제 결제금액과 다를 수 있습니다.</Item>
      <Item>
        • 예상 최저가 계산에 적용했던 쿠폰과 다른 쿠폰을 적용하실 경우, 실제 결제금액이 다를 수 있습니다.
      </Item>
      <Item>• 혜택별 적용 조건(등급, 첫 구매 등)에 따라 로그인 시 예상 최저가가 다시 계산될 수 있습니다.</Item>
      <Item>
        • 첫 구매 상품은 유저당 1회, 1개만 주문 가능하며, 결제금액이 첫 구매 최소 주문 금액 이상일 경우 주문 가능합니다.
      </Item>
    </Info>
  );
}

const Info = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  line-height: 140%;
  color: ${vars.v3Color.gray500};
`;

const Item = styled.p`
  position: relative;
  line-height: 18px;
`;

const ItemStrong = styled.p`
  position: relative;
  line-height: 18px;
  font-weight: 500;
  color: ${vars.v3Color.gray600};
`;

const Strong = styled.span`
  color: ${vars.v3Color.pink400};
`;
